import { schema, normalize } from 'normalizr';
import { createActions, asyncAction } from '../helpers/redux';
import union from 'lodash/union';
// import {ws} from '../ws/client';

const organizationSchema = new schema.Entity('organizations');
const avatarSchema = new schema.Entity('avatars');
const userSchema = new schema.Entity('users');
const roleSchema = new schema.Entity('roles');

userSchema.define({
  avatar: avatarSchema,
});

const organizationUserSchema = new schema.Entity(
  'organizationUsers',
  {
    user: userSchema,
    role: roleSchema,
  },
  {
    idAttribute(entity) {
      return entity.user.id;
    },
  },
);

// organizationUserSchema.define({
//   user: userSchema,
//   role: roleSchema,
// });

const pendingOrganizationUserSchema = new schema.Entity(
  'pendingOrganizationUsers',
);

const organizationUserAllSchema = new schema.Entity(
  'organizationUserAll',
  {
    organizationUsers: [organizationUserSchema],
    pendingOrganizationUsers: [pendingOrganizationUserSchema],
  },
  {
    idAttribute() {
      return 0;
    },
  },
);

// organizationUserAllSchema.define({
//   organizationUsers: [organizationUserSchema],
//   pendingOrganizationUsers: [pendingOrganizationUserSchema],
// });

export const OrganizationActions = createActions({
  @asyncAction()
  async changeUserRole(organizationId, userId, roleId) {
    return ({ client }) =>
      client
        .patch(`/organization/${organizationId}/users/${userId}`, {
          body: { role_id: roleId },
        })
        .then(response => response);
  },

  setOrganizationId(organizationId) {
    return {
      organizationId,
    };
  },

  @asyncAction()
  async addUser(organizationId, user) {
    return ({ client }) =>
      client
        .post(`/organizations/${organizationId}/users`, { body: user })
        .then(response => normalize(response, organizationUserAllSchema));
  },

  @asyncAction()
  async removeUser(organizationId, userId) {
    return ({ client }) =>
      client
        .delete(`/organization/${organizationId}/users/${userId}`)
        .then(response => response);
  },

  @asyncAction()
  async removePendingUser(organizationId, userId) {
    return async ({ client }) => {
      await client.delete(
        `/organization/${organizationId}/pendingusers/${userId}`,
      );
      return { organizationId, userId };
    };
  },

  @asyncAction()
  async getOrganizations(options) {
    return ({ client }) =>
      client
        .get('/organizations', {
          qs: { fields: union(['type'], options.fields).join(',') },
        })
        .then(response => normalize(response, [organizationSchema]));
  },

  @asyncAction()
  async getOrganization(organizationId) {
    return ({ client }) =>
      client
        .get(`/organizations/${organizationId}`)
        .then(response => normalize(response, organizationSchema));
  },

  @asyncAction()
  async getOrganizationUsers(organizationId) {
    return ({ client }) =>
      client
        .get(`/organization/${organizationId}/users`)
        .then(response => normalize(response, organizationUserAllSchema));
  },

  @asyncAction()
  async createOrganization(organization) {
    return ({ client }) =>
      client
        .post('/organizations', { body: organization })
        .then(response => normalize(response, organizationSchema));
  },

  @asyncAction()
  async deleteOrganization(organizationId) {
    return ({ client }) =>
      client
        .delete(`/organizations/${organizationId}`)
        .then(response => response);
  },

  @asyncAction()
  async renameOrganization(organizationId, orgnizationName) {
    return ({ client }) => {
      return client
        .patch(`/organization/${organizationId}`, {
          body: { fields: { name: orgnizationName } },
        })
        .then(response => {
          return normalize(response, organizationSchema);
        });
    };
  },
});



// WEBPACK FOOTER //
// ./src/actions/organization.js